<template>

    <div class="page-center content-load">

        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-xl-4 col-xl-offset-4">

                    <div class="login-register-page" v-show="modo == 'confirmar'">
                        
                        <center>
                            <img src="static/images/logo.png" width="180" class="logo">
                        </center>

                        <div class="welcome-text margin-top-30">
                            <h2>Você poderá comparecer na consulta?</h2>
                        </div>

                        <div class="row">                                                               

                            <div class="col-lg-6 col-xs-6">
                                <button class="button border-red full-width outline margin-top-10 margin-bottom-10" type="button" v-on:click="form.status = 'N';" v-bind:class="{'red': form.status == 'N'}">
                                    <i class="material-icons">close</i>
                                    Não
                                </button>
                            </div> 
                            <div class="col-lg-6 col-xs-6">
                                <button class="button border-green full-width outline margin-top-10 margin-bottom-10" type="button" v-on:click="form.status = 'S'; submit();" v-bind:class="{'green': form.status == 'S'}">
                                    <i class="material-icons">check_circle</i>
                                    Sim
                                </button>
                            </div>

                            <div class="col-lg-12 col-xs-12" v-if="form.status == 'N'">
                                <hr>
                                <h5>Que pena! Qual o motivo?</h5>
                                <textarea class="with-border" v-model="form.motivo" name="motivo" placeholder="Escreva o motivo aqui.." required/>
                                <button class="button gray full-width margin-top-10 margin-bottom-30" type="button" v-on:click="submit();">
                                    <i class="material-icons">send</i>
                                    Enviar
                                </button>                                        
                            </div>
                        </div>
                    </div>

                    <div class="login-register-page" v-show="modo == 'confirmado'">
                        
                        <center>
                            <img src="static/images/logo.png" width="180" class="logo margin-bottom-30">
                            <i class="material-icons" style="font-size: 10em; display: block; color: #59ba92">check_circle</i>
                        </center>

                        <div class="welcome-text margin-top-20">
                            <h2>Agendamento atualizado. Obrigado pela atenção.</h2>
                        </div>

                        <div class="row">                                                               


                            <div class="col-lg-12 col-xs-8 col-xs-offset-2 col-xl-offset-0 col-lg-offset-0">
                                <a target="_blank" :href="$root.config.whatsapp" class="button green full-width margin-top-10 margin-bottom-30">
                                    Chamar no WhatsApp
                                    <!-- <i class="material-icons">send</i> -->
                                </a>                                        
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>  
    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'ConfirmarAgendamento',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            loading: {
                "submit":           false,
            },
            modo:                   "confirmar",
            form: {
                "cod":              "",
                "status":           "",
                "acao":             "confirmar",
                "motivo":           ""
            }            
        }
    },
    methods: {
        submit: function(e) {
            var self            = this;
            console.log("submit", e, self.form, JSON.stringify(self.form));
            
            confirm("Você tem certeza?", function() {
                loading.show();
                axios.put("api/agendamento.php", self.form)
                .then(response => {
                    
                    console.log("ok", response)
                    loading.hide();
                    self.modo = "confirmado";
                    self.$forceUpdate();
                    alert(response.data.message);
           
                })
                .catch(error => {
                    loading.hide();
                    self.loading.submit = false;
                    alert(error.response.data.message || "Erro! Por favor, tente novamente.");
                });
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "cod":  self.$route.query.c
                    }
                };

                axios.get("api/notificacoes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    if (!response.data.result.cod) {
                        window.location.href = self.$root.config.site;                                 
                        return false;
                    }
                    if (response.data.result.statusInteracao == 1) {
                        self.modo = "confirmado";
                        self.$forceUpdate();
                    }
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            window.location.href = self.$root.config.site;                             
                        }
                    }                    
                });   
            });   
        }           
    },    
    created: function() {
        var self = this;
        if (!self.$route.query.c) {
            self.$router.push({ 
                name:       "Login",
            }).catch(()=>{});                  
            return false;
        }
        self.form.cod              = self.$route.query.c;        
        self.get();      
    },     
    mounted: function() {
        // loading.hide();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .page-confirmaragendamento button.outline {
        background: transparent;
        font-weight: 700;
    }
    .page-confirmaragendamento .mmenu-trigger {
        display: none !important;
    }   
    .page-confirmaragendamento #wrapper {
        padding-top: 0px !important;
    }
    .page-confirmaragendamento .border-green {
        border: 2px solid #30ab4a !important;
        color: #30ab4a
    }
    .page-confirmaragendamento .border-red {
        border: 2px solid #dc3139 !important;
        color: #dc3139
    }
</style>



// WEBPACK FOOTER //
// src/components/ConfirmarAgendamento.vue